import React, { useEffect, Fragment, useState, useRef } from 'react';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { LoadingComponent } from 'recupero-comunes';
import { FaSearch } from "react-icons/fa";
import { serviceGetHistoriaGastos, serviceGetInforme } from '../../api/api-consulta-hitos';
import { descargarArchivo } from '../../common/descargarArchivo';
import { formato_monto } from '../../common/Formatos';


const ConsultaGastosHonorarios = ({ showModal, setShowModal, idCaso, idOrgCaso }) => {
    const { SearchBar, ClearSearchButton } = Search;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const columnas = [
        {
            dataField: 'glosaCobertura',
            text: 'Tipo Gasto/Hono.',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'nombreImplicado',
            text: 'Implicado', sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaOcurrenciaFormat',
            text: 'Fecha Ocurrencia',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'glosaMoneda',
            text: 'Moneda',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'montoProvision',
            text: 'Monto Provisión',
            sort: true, headerAlign: 'center', align: 'center',
            formatter: (cell, row) => <span>{formato_monto(row.montoProvision, false)}</span>,
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'comentario',
            text: 'Comentario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'usuario',
            text: 'Usuario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaIngresoFormat',
            text: 'Fecha Registro',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'opciones',
            text: '',
            isDummyField: true,
            style: { textAlign: 'center', verticalAlign: 'middle' },
            headerStyle: (colum, colIndex) => {
                return { width: '5%', textAlign: 'center', verticalAlign: 'center', backgroundColor: '#7594C1', color: 'white' }
            },
            formatter: (cell, row) => {
                return <FaSearch
                    size={20}
                    title={row.idfolioCargaDocto ? "Ver Documentación del Hito" : "No existe documentación"}
                    style={{ color: 'gray', cursor: row.idfolioCargaDocto ? 'pointer' : 'not-allowed' }}
                    onClick={() => handleInforme(row.idImplicado, row.idfolioCargaDocto)}
                />
            },
        }
    ];

    useEffect(() => {
        if (showModal) getHistoriaGastos();
    }, [showModal])

    const getHistoriaGastos = async () => {
        setLoading(true);
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado: 999 })).toString('base64');

        const response = await serviceGetHistoriaGastos(query);
        setLoading(false);
        setData(response);
    }

    const handleInforme = async (idImplicado, folioCarga) => {
        if (folioCarga) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: idImplicado ? idImplicado : 0,
                idCompania: idOrgCaso,
                idfolioCarga: folioCarga
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            descargarArchivo(response);
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <Card>
                    <Card.Header className='cardHeader'>
                        GASTOS / HONARARIO - PROVISIONES
                    </Card.Header>

                    <Card.Body>
                        <Row>
                            <Col className="d-grid d-md-flex justify-content-md-end">
                                <Button className='w-auto' variant='outline-info' onClick={() => setShowModal(false)}>Volver</Button>
                            </Col>
                        </Row>

                        <hr style={{ borderTop: '3px solid #04005D' }}></hr>

                        <ToolkitProvider
                            search
                            bootstrap4
                            keyField="id"
                            data={data ? data : []}
                            columns={columnas}
                            defaultSorted={[{ dataField: 'id', order: 'asc' }]}>
                            {props =>
                                <>
                                    <Row>
                                        <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                                            <SearchBar {...props.searchProps} srText="" placeholder="Buscar en grilla" />
                                            <ClearSearchButton {...props.searchProps} text="Limpiar" className="customSearch" />
                                        </Col>
                                    </Row>
                                    <BootstrapTable
                                        {...props.baseProps}
                                        headerWrapperClasses="table-secondary"
                                        pagination={ paginationFactory({ sizePerPage: 5}) }
                                        noDataIndication={
                                            <div className="text-center">No hay registros encontrados.</div>
                                        }
                                    />
                                </>
                            }
                        </ToolkitProvider>
                    </Card.Body>
                </Card>
            </Modal>

            <style type='text/css'>
                {`
                    .table>:not(:first-child) {
                        border-top: none;
                    }
                    .customSearch {
                        color: #fff;
                        background-color: #ffc107;
                        border-color: #ffc107;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default ConsultaGastosHonorarios